import Backbone from 'backbone'
import _ from 'underscore'
import ContentHeaderView from '../../../views/content-header'
import TimesTableItemView from './times-table-item'
import TimesTableOrderView from './times-table-order'
import TimesTableView from './times-table'
import config from '../../../config'

const TimesTableOneToSixView = Backbone.View.extend({
    el: '#current-view',
    tagName: 'div',
    id: 'test-view',
    tables: [1, 2, 3, 4, 5, 6],
    modelyModel: Backbone.Model.extend({
        defaults: {
            state: 'tables',
            table: 1,
            in_order: true
        }
    }),
    initialize() {
        // reset the test model
        this.model.get('test').reset()

        // set the mode
        this.model.set('mode', 'test')
        
        this.template = _.template(`
            <div id="content-view">
                <div id="header"></div>
                <div id="sub-view" class="<%- color %> <%- mode %>">
                    <div id="test-view"></div>
                </div>
            </div>
        `)

        this.modely = new this.modelyModel({
            state: 'tables',
            table: 1,
            in_order: true
        })

        this.listenTo(this.modely, 'change', this.render)
    },
    render() {
        this.$el.html(this.template({
            color: this.model.get('color'),
            mode: 'test',
        }))

        const headerView = new ContentHeaderView({model: this.model})
        this.$('#header').append(headerView.render().el)

        switch (this.modely.get('state')) {
            case 'tables':
                this.$('#test-view').addClass('f3_menu_wrap')
                this.$('#test-view').append(`<div class="f3_menu_title">Select a times table.</div>`)
                _.each(this.tables, (table) => {
                    const timesTableItemView = new TimesTableItemView({
                        model: this.modely,
                        table: table
                    })
                    this.$('#test-view').append(timesTableItemView.render().el)
                })
                break
            case 'order':
                this.$('#test-view').addClass('f3_menu_choice_wrap')
                this.$('#test-view').append(`<p class="f3_menu_title">For the test to start, select whether you want to be tested in order or at random.</p>`)
                _.each([true, false], (in_order) => {
                    const timesTableOrderView = new TimesTableOrderView({
                        model: this.modely,
                        in_order: in_order
                    })
                    this.$('#test-view').append(timesTableOrderView.render().el)
                })
                break
            case 'game':
                const timesTableView = new TimesTableView({
                    model: this.modely,
                    testModel: this.model.get('test'),
                    titleModel: this.model
                })
                this.$('#test-view').append(timesTableView.render().el)
                break
            case 'result':
                this.model.get('test').set('end_timestamp', new Date().getTime())

                // navigate to the results screen
                const image_prefix = this.model.get('image_prefix')
                const slug = config.get('slug')
                Backbone.history.navigate(`app/${slug}/test-result/${image_prefix}`, { trigger: true })
        }
        return this
    }
})

export default TimesTableOneToSixView
